import { streakAchievement } from './helpers';

export default streakAchievement(100, 220);
